export var LibraryKind;
(function (LibraryKind) {
    LibraryKind["Rectangle"] = "rectangle";
    LibraryKind["Text"] = "text";
    LibraryKind["Image"] = "image";
    LibraryKind["Video"] = "video";
    LibraryKind["Ellipse"] = "ellipse";
    LibraryKind["Button"] = "button";
    LibraryKind["Widget"] = "widget";
    LibraryKind["Feeds"] = "feeds";
    LibraryKind["Effects"] = "effects";
    LibraryKind["Selection"] = "selection";
    LibraryKind["Any"] = "any";
})(LibraryKind || (LibraryKind = {}));
export var LibraryViewMode;
(function (LibraryViewMode) {
    LibraryViewMode["List"] = "list";
    LibraryViewMode["Grid"] = "grid";
    LibraryViewMode["Preview"] = "preview";
})(LibraryViewMode || (LibraryViewMode = {}));
